var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStopDuration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.13604 6.63604C5.30031 7.47177 4.63738 8.46392 4.18508 9.55585C3.73279 10.6478 3.5 11.8181 3.5 13C3.5 14.1819 3.73279 15.3522 4.18508 16.4442C4.63738 17.5361 5.30031 18.5282 6.13604 19.364C6.97177 20.1997 7.96392 20.8626 9.05585 21.3149C10.1478 21.7672 11.3181 22 12.5 22C13.6819 22 14.8522 21.7672 15.9442 21.3149C17.0361 20.8626 18.0282 20.1997 18.864 19.364L17.4983 17.9983C16.842 18.6547 16.0627 19.1754 15.2051 19.5307C14.3475 19.8859 13.4283 20.0687 12.5 20.0687C11.5717 20.0687 10.6525 19.8859 9.79492 19.5307C8.9373 19.1754 8.15805 18.6547 7.50166 17.9983C6.84527 17.342 6.32459 16.5627 5.96935 15.7051C5.61411 14.8475 5.43127 13.9283 5.43127 13C5.43127 12.0717 5.61411 11.1525 5.96935 10.2949C6.32459 9.4373 6.84526 8.65805 7.50166 8.00166L6.13604 6.63604Z",
    fill: "#F4844D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0461 17.9047C21.1698 16.1759 21.6657 14.1138 21.4511 12.0632C21.2365 10.0126 20.3243 8.0978 18.8671 6.63916C17.4099 5.18052 15.496 4.26645 13.4456 4.04982C11.3952 3.83318 9.3326 4.32713 7.60274 5.44905L8.65363 7.06938C10.0123 6.18821 11.6323 5.80025 13.2427 5.9704C14.8531 6.14055 16.3563 6.85847 17.5008 8.00411C18.6453 9.14975 19.3618 10.6536 19.5303 12.2642C19.6989 13.8748 19.3093 15.4944 18.4268 16.8522L20.0461 17.9047Z",
    fill: "#F4844D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 4.5L18 6L19.5 7.5L21 6L19.5 4.5Z",
    fill: "#F4844D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 3V1H15.5V3H9.5Z",
    fill: "#F4844D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.5L3.5 4L21 21.5L19.5 23L2 5.5Z",
    fill: "#F4844D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 8H11.5V9.5L13.5 11.5V8Z",
    fill: "#F4844D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopDuration);
export default __webpack_public_path__ + "static/media/stop-duration.7d3f9d0177d253c397884e178c54d3d8.svg";
export { ForwardRef as ReactComponent };